import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, UtensilsCrossed, Lamp, Sparkles, Heart, Gift } from 'lucide-react';

const hubs = [
  {
    title: 'Ramadan',
    desc: 'Alles rund um den Fastenmonat – Geschenke, Deko, Rezepte & Tipps',
    path: '/ramadan',
    icon: Lamp,
    accent: 'from-[#4A5D4F] to-[#3A493E]',
  },
  {
    title: 'Geschenkideen',
    desc: 'Geschenke für Kinder, Frauen, Männer & Familien – für jedes Budget',
    path: '/geschenke',
    icon: Gift,
    accent: 'from-[#5C6B61] to-[#4A5D4F]',
  },
  {
    title: 'Rezepte & Kulinarik',
    desc: 'Iftar-Rezepte, Eid-Frühstück, Süßigkeiten & Dattelsorten',
    path: '/ratgeber/eid-fruehstueck-ideen',
    icon: UtensilsCrossed,
    accent: 'from-[#6B7B6F] to-[#4A5D4F]',
  },
  {
    title: 'Dekoration',
    desc: 'Eid Deko, DIY Ideen, Tischdeko & Ramadan Lichter',
    path: '/ratgeber/eid-deko-ideen',
    icon: Sparkles,
    accent: 'from-[#4A5D4F] to-[#5C6B61]',
  },
  {
    title: 'Wissen & Spiritualität',
    desc: 'Was ist Eid? Ramadan für Anfänger, Zakat, Bedeutung der Feste',
    path: '/ratgeber/ramadan-fuer-anfaenger',
    icon: Heart,
    accent: 'from-[#3A493E] to-[#4A5D4F]',
  },
  {
    title: 'Alle Ratgeber',
    desc: 'Über 30 hilfreiche Artikel zu Eid, Ramadan und dem Schenken',
    path: '/ratgeber',
    icon: BookOpen,
    accent: 'from-[#5C6B61] to-[#3A493E]',
  },
];

export const ContentHubSection = () => {
  return (
    <section className="py-20 md:py-28 bg-[#FDFCF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-sm font-medium tracking-widest uppercase text-[#4A5D4F] mb-4 block">
            Entdecken
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-medium text-[#2C332E] mb-4">
            Dein Eid & Ramadan Hub
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
            Alles was du für ein perfektes Eid brauchst – Geschenke, Rezepte, Deko-Ideen und Wissen an einem Ort.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hubs.map((hub) => (
            <Link
              key={hub.path}
              to={hub.path}
              data-testid={`hub-${hub.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="group relative bg-gradient-to-br overflow-hidden rounded-2xl p-6 md:p-7 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              style={{ backgroundImage: `linear-gradient(135deg, #4A5D4F, #3A493E)` }}
            >
              <div className="relative z-10">
                <hub.icon className="w-7 h-7 text-[#D4C5A9] mb-4" />
                <h3 className="font-serif text-xl font-medium text-white mb-2">{hub.title}</h3>
                <p className="text-white/65 text-sm leading-relaxed mb-4">{hub.desc}</p>
                <span className="inline-flex items-center text-[#D4C5A9] text-sm font-medium gap-1.5 group-hover:gap-2.5 transition-all">
                  Entdecken <ArrowRight className="w-4 h-4" />
                </span>
              </div>
              <div className="absolute top-3 right-3 w-16 h-16 rounded-full bg-white/5 group-hover:scale-125 transition-transform duration-500" />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-white/5 group-hover:scale-110 transition-transform duration-500" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
